
/* 
------- this function takes care of filtering new data like new customers, new distributors
-------- you get the point
 */
export function FilterNewData(dataList) {
    let filteredArray = [];
    if (dataList) {
      dataList.data.forEach(singleData => {
        const oneDay = 24 * 60 * 60 * 1000;
        let createdDate = new Date(singleData.createdAt);
        // console.log(createdDate);
        let totalDays = Math.round(Math.abs((createdDate - Date.now()) / oneDay));
        // console.log(totalDays);
        if (totalDays < 14) {
          singleData.new = true;
        } else {
          singleData.new = false;
        }
        filteredArray.push(singleData);
      });
      // select only where new = true
      let trueEleArr = [];
      filteredArray.forEach(arrElement => {
        if (arrElement.new) {
          trueEleArr.push(arrElement);
        }
      });
      dataList.data = trueEleArr;
      dataList.totalRecords = dataList.data.length;
      return dataList;
    }
    return dataList;
}
  
export function filterNewData14DaysAgo(dataList) {
  let filteredArray = [];
  let newDataList = [];
	if (dataList) {
		dataList.data.forEach((singleData) => {
			const oneDay = 24 * 60 * 60 * 1000;
			let createdDate = new Date(singleData.createdAt);
			// console.log(createdDate);
			let totalDays = Math.round(Math.abs((createdDate - Date.now()) / oneDay));
			// console.log(totalDays);
			if (totalDays < 14) {
				singleData.new = true;
			} else {
				singleData.new = false;
			}
			filteredArray.push(singleData);
		});
		// select only where new = true
		
		filteredArray.forEach((arrElement) => {
			if (arrElement.new) {
				newDataList.push(arrElement);
			}
		});
		return newDataList;
	}
	return newDataList;
}
  
  /* 
  ------- custom labels for paginations
  -------- this object is used in the paginationMixin
   */
  export const customLabels = {
    first: "<<",
    last: ">>",
    previous: "<",
    next: ">"
  };
  
  /* 
  ------- this function takes care of filtering 
  -------- you get the point
   */
  export function FilterActive(dataList) {
    let newList = [];
    dataList.data.forEach(center => {
      if (center.isActive) {
        newList.push(center);
      }
    });
    dataList.data = newList;
    dataList.totalRecords = dataList.data.length;
    return dataList;
  }
  
  export function FilterActiveStatus(dataList) {
    let newList = [];
    dataList.data.forEach(center => {
      if (center.status) {
        newList.push(center);
      }
    });
    dataList.data = newList;
    dataList.totalRecords = dataList.data.length;
    return dataList;
  }
  
  export function FilterInactive(dataList) {
    let newList = [];
    dataList.data.forEach(center => {
      if (!center.isActive) {
        newList.push(center);
      }
    });
    dataList.data = newList;
    dataList.totalRecords = dataList.data.length;
    return dataList;
  }
  
  export function FilterInactiveStatus(dataList) {
    let newList = [];
    dataList.data.forEach(center => {
      if (!center.status) {
        newList.push(center);
      }
    });
    dataList.data = newList;
    dataList.totalRecords = dataList.data.length;
    return dataList;
  }


  export function IsJsonString(str) {
		try {
			JSON.parse(str);
		} catch (e) {
			return false;
		}
		return true;
	}
